import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICompletedCharacterSlots } from 'src/app/store/characterState/characterState.reducer';

@Component({
  selector: 'app-character-frame',
  templateUrl: './character-frame.component.html',
  styleUrls: ['./character-frame.component.scss'],
})
export class CharacterFrameComponent implements OnInit {
  @Input() characterSlot: ICompletedCharacterSlots | undefined;
  @Input() showName: boolean | undefined;
  @Input() slimFrame: boolean | undefined;
  @Input() boldFrame: boolean | undefined;
  @Input() hideFrame: boolean | undefined;
  @Output() openCharacterSelectionEvent: EventEmitter<Event> =
    new EventEmitter<Event>();
  constructor() {}

  ngOnInit(): void {}
  public openCharacterSelection(): void {
    if (this.boldFrame) {
      this.openCharacterSelectionEvent.emit();
    }
  }
}
